<template>
   <h1>Promo Page</h1>
</template>